import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center px-6 py-12 gap-3",
        className,
      )}
    >
      {icon && <div className="text-text-muted">{icon}</div>}
      <div className="font-sans text-base font-medium text-text-primary">
        {title}
      </div>
      {description && (
        <p className="font-sans text-sm text-text-muted max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
